// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ContasRecebimentos_CarregaRecebimentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /contas/recebimentos/carrega_recebimento/{recebimento_id}
 *
 * Returns a single recebimento. The model's busca_recebimento() runs
 * `SELECT * FROM contas_recebimentos` and returns ->row(), so dados carries
 * every PHYSICAL column of the table (superset of the to_object() metadata
 * shape used by the listing endpoints).
 *
 * All fields are nullable because the response is built directly from a raw
 * DB row object via getDados() reflection; not-null DB columns still map onto
 * nullable contract properties here, which is the lenient single-record
 * convention used by the canonical Recebimentos_CarregaRecebimentoResponse.
 *
 * DO NOT EDIT THE TYPESCRIPT SIBLING MANUALLY — this PHP file is the single
 * source of truth; the .ts is regenerated via scripts/sync-contracts/sync-from-php.sh.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ContasRecebimentos_CarregaRecebimentoResponseDados {
recebimento_id?: number
recebimento_data_cadastro?: string
recebimento_franquia_id?: number
recebimento_franquia_nome?: string
recebimento_conta_id?: number
recebimento_conta_nome?: string
recebimento_forma_pagamento_id?: number
recebimento_forma_pagamento_nome?: string
recebimento_origem?: string
recebimento_origem_id?: number
recebimento_registrado_por?: string
recebimento_registrado_por_id?: string
recebimento_valor?: number
recebimento_provedor?: string
recebimento_id_externo?: string
recebimento_observacoes?: string
recebimento_conta_externa_id?: number
recebimento_data?: string
recebimento_payroll_period_id?: number
recebimento_valor_taxas?: number
recebimento_valor_liquido?: number
recebimento_data_disponivel?: string
}

export type ContasRecebimentos_CarregaRecebimentoResponse = ApiResponse<ContasRecebimentos_CarregaRecebimentoResponseDados>;

registerResponseContract('ContasRecebimentos_CarregaRecebimentoResponse', {
  recebimento_id:                   { type: 'number',  required: false },
  recebimento_data_cadastro:        { type: 'string',  required: false },
  recebimento_franquia_id:          { type: 'number',  required: false },
  recebimento_franquia_nome:        { type: 'string',  required: false },
  recebimento_conta_id:             { type: 'number',  required: false },
  recebimento_conta_nome:           { type: 'string',  required: false },
  recebimento_forma_pagamento_id:   { type: 'number',  required: false },
  recebimento_forma_pagamento_nome: { type: 'string',  required: false },
  recebimento_origem:               { type: 'string',  required: false },
  recebimento_origem_id:            { type: 'number',  required: false },
  recebimento_registrado_por:       { type: 'string',  required: false },
  recebimento_registrado_por_id:    { type: 'string',  required: false },
  recebimento_valor:                { type: 'number',  required: false },
  recebimento_provedor:             { type: 'string',  required: false },
  recebimento_id_externo:           { type: 'string',  required: false },
  recebimento_observacoes:          { type: 'string',  required: false },
  recebimento_conta_externa_id:     { type: 'number',  required: false },
  recebimento_data:                 { type: 'string',  required: false },
  recebimento_payroll_period_id:    { type: 'number',  required: false },
  recebimento_valor_taxas:          { type: 'number',  required: false },
  recebimento_valor_liquido:        { type: 'number',  required: false },
  recebimento_data_disponivel:      { type: 'string',  required: false },
})
